export const addresses = {
  starAddress: "0xeb52De49a1C1Fc402577b772f0ea6442d263C2DC",
};
